import ConfigProvider from '../Core/Configuration/ConfigProvider';
import BucketHelper from '../Core/Bucket/BucketHelper';
import NotaHelper from '../Nota/NotaHelper';
import ApiContenidosService from '../Services/ApiContenidosService';

const TITLE_CINE = "CINE";
const TITLE_TEATRO = "TEATRO";
let $module;
export default class UltimasNotas {
    constructor(options) {
        const {
            max = 3
        } = options;

        this.max = max;
        $module = document.querySelector('[data-module="UltimasDe"]');
    }

    LoadUltimasDeCine() {
        if (!$module)
            return;

        ApiContenidosService.GetNotasByCategoria(121, this.max)
            .then(notas => _Render(TITLE_CINE, notas));
    }


    LoadUltimasDeTeatro() {
        if (!$module)
            return;

        ApiContenidosService.GetNotasByCategoria(126, this.max)
            .then(notas => _Render(TITLE_TEATRO, notas));
    }


}
function _Render(section, notas) {
    let notasHtml = '';

    notas.forEach((nota) => {
        notasHtml += _getNotaHtml(nota);
    });

    $module.innerHTML = `
            <h4 class="titulo">
                <span class="text-highlighted">
                    ÚLTIMAS <b>DE ${section}</b>
                </span>
            </h4>
            <ol class="ranking">
                ${notasHtml}
            </ol>`;
}

function _getNotaHtml(nota) {
    let img = '';

    if (NotaHelper.HasImage(nota)) {
        img = `<img src="${BucketHelper.GetUrl(ConfigProvider.BucketUrl, nota.imagenes[0].src, 198)}" />`;
    }

    return `
        <li>
            <article class="nota" data-notaid="${nota.id}">
                <a href="/${nota.url}" class="figure">${img}</a>    
                <h2>
                    <a href="/${nota.url}">${nota.titulo}</a>
                </h2>   
            </article>
        </li>`;
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/UltimasNotas.js